export default __webpack_public_path__ + "static/media/Icon_Class_OceanWalker.2790e7d4.png";